// Password reset — confirm step. Reached from the link in the reset email:
//   #/reset-password?token=<TOKEN>
// Reads the token, takes a new password, and completes the reset via PocketBase.
// Reachable by guests (you're signed out when resetting).
import { confirmPasswordReset } from "../lib/auth.js";
import { openAuthPanel } from "../ui/authPanel.js";
import { navigate } from "../router/router.js";

export function resetPasswordView(app, params = {}) {
  const token = params.token || "";

  if (!token) {
    app.innerHTML = `
      <section class="max-w-sm mx-auto py-16 text-center">
        <p class="text-4xl mb-3">🔒</p>
        <h2 class="text-2xl font-bold text-sage-800">Reset link missing</h2>
        <p class="text-sage-600 text-sm mt-2 mb-5">This page needs a valid reset link. Open the most recent link from your email, or request a new one.</p>
        <button id="rp-open-signin" class="bg-sage-500 hover:bg-sage-600 text-white px-5 py-2.5 rounded-lg text-sm font-medium">Back to sign in</button>
      </section>`;
    app.querySelector("#rp-open-signin").addEventListener("click", () => {
      navigate("dashboard");
      openAuthPanel("signin");
    });
    return;
  }

  app.innerHTML = `
    <section class="max-w-sm mx-auto py-12">
      <h2 class="text-2xl font-bold text-sage-800 text-center mb-1">Set a new password</h2>
      <p class="text-sage-600 text-sm text-center mb-5">Choose a new password for your account.</p>
      <form id="rp-form" class="bg-white border border-sage-100 rounded-2xl p-5 space-y-3">
        <label class="block">
          <span class="text-xs text-sage-500">New password</span>
          <input name="password" type="password" required minlength="8" autocomplete="new-password"
            class="mt-1 w-full rounded-lg border border-sage-200 focus:border-sage-500 focus:ring-2 focus:ring-sage-200 outline-none text-sm p-2" />
        </label>
        <label class="block">
          <span class="text-xs text-sage-500">Confirm new password</span>
          <input name="passwordConfirm" type="password" required minlength="8" autocomplete="new-password"
            class="mt-1 w-full rounded-lg border border-sage-200 focus:border-sage-500 focus:ring-2 focus:ring-sage-200 outline-none text-sm p-2" />
        </label>
        <p id="rp-error" class="text-xs text-red-600 min-h-[1rem]"></p>
        <button type="submit" id="rp-submit"
          class="w-full bg-sage-500 hover:bg-sage-600 text-white text-sm font-medium rounded-lg py-2.5 transition">Set password</button>
      </form>
    </section>`;

  const form = app.querySelector("#rp-form");
  const errEl = app.querySelector("#rp-error");
  const btn = app.querySelector("#rp-submit");

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errEl.textContent = "";
    const fd = new FormData(form);
    const pw = String(fd.get("password") || "");
    const pc = String(fd.get("passwordConfirm") || "");
    if (pw !== pc) {
      errEl.textContent = "The passwords don't match.";
      return;
    }
    btn.disabled = true;
    btn.textContent = "Saving…";
    try {
      await confirmPasswordReset(token, pw, pc);
      app.innerHTML = `
        <section class="max-w-sm mx-auto py-16 text-center">
          <p class="text-4xl mb-3">✅</p>
          <h2 class="text-2xl font-bold text-sage-800">Password updated</h2>
          <p class="text-sage-600 text-sm mt-2 mb-5">You can now sign in with your new password.</p>
          <button id="rp-signin" class="bg-sage-500 hover:bg-sage-600 text-white px-5 py-2.5 rounded-lg text-sm font-medium">Sign in</button>
        </section>`;
      app.querySelector("#rp-signin").addEventListener("click", () => {
        navigate("dashboard");
        openAuthPanel("signin");
      });
    } catch (err) {
      errEl.textContent =
        err?.message || "That reset link is invalid or has expired. Please request a new one.";
      btn.disabled = false;
      btn.textContent = "Set password";
    }
  });

  window.scrollTo({ top: 0, behavior: "smooth" });
}
